/*
 * Estado do menu do usuário: aberto ou fechado, a aba ativa e a rota em que
 * ele abriu. Fica fora dos componentes porque o botão do avatar, o painel e
 * os ouvintes globais (Esc, clique fora) precisam ler e mudar o mesmo valor —
 * e porque o cabeçalho pode ser redesenhado do zero ao trocar de página.
 */
import { warmMenu } from './warm';
export const DEFAULT_TAB = 'all-notifications';
class UserMenuState {
  open = false;
  tab = DEFAULT_TAB;

  /** A rota de quando abriu: ao navegar, o menu fecha. */
  route = null;

  /** Devolver o foco ao avatar só quando quem fechou foi o teclado. */
  restoreFocus = false;
  show() {
    this.open = true;
    // O menu sempre reabre em "Todas as notificações".
    this.tab = DEFAULT_TAB;
    this.route = m.route.get();

    // As listas já vieram ao apontar o avatar ou com a página ociosa; aqui,
    // a primeira busca de quem não apontou ou a revalidação, sem esvaziar a
    // lista que está na tela (warm.ts).
    warmMenu(true);
  }
  close(restoreFocus = false) {
    if (!this.open) return;
    this.open = false;
    this.restoreFocus = restoreFocus;
  }
  toggle() {
    if (this.open) this.close();else this.show();
  }
}
export const userMenu = new UserMenuState();
flarum.reg.add('ramon-canela', 'forum/usermenu/state', { DEFAULT_TAB: DEFAULT_TAB,userMenu: userMenu, });